/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { UpdateUserPreferencesOptions, UpdateUserPreferencesResponses } from '../../models/UpdateUserPreferences'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Update Preferences
 * {@link /user/preferences}
 */
export function updateUserPreferences<ThrowOnError extends boolean = true>(options: Options<UpdateUserPreferencesOptions, ThrowOnError>): Promise<UnwrappedResult<UpdateUserPreferencesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'PATCH', url: '/user/preferences', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<UpdateUserPreferencesResponses, ThrowOnError>>
}
